import { css } from 'linaria';

export const section = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  background-color: var(--background-accent);
  border-radius: var(--rounding-l);

  @media (--to-desktop) {
    flex-direction: column;
  }

  @media (--only-mobile) {
    margin: 0 auto 40px;
    background-color: var(--text-invert);
  }
`;

export const title = css`
  && {
    @media (--only-mobile) {
      color: var(--text-primary);
    }
  }
`;

export const info = css`
  position: relative;
  width: 450px;
  margin: 80px 80px 0;

  @media (--only-desktop) {
    width: 390px;
    margin: 64px 32px 0 64px;
  }

  @media (--only-tablet) {
    width: 532px;
    margin: 40px 64px 48px;
  }

  @media (--only-mobile) {
    width: 100%;
    margin: 0 0 36px;
  }
`;

export const text = css`
  && {
    white-space: pre-wrap;

    @media (--only-mobile) {
      line-height: 22px;
      color: var(--text-primary);
    }
  }
`;
